import { SubIdExperienceVariant } from '../../config/enums';

export type SitePreviewCtaTarget = 'premium' | 'dashboard';

interface OfferCardContent {
  urgencyKey?: string;
  discountKey?: string;
  descriptionKey?: string;
  buttonKey: string;
  footerPrefixKey?: string;
  footerHighlightKey?: string;
}

interface ExperienceContent {
  titleKey: string;
  subtitleKey: string;
  offerCard: OfferCardContent;
}

export interface SitePreviewExperience {
  ctaTarget: SitePreviewCtaTarget;
  content: ExperienceContent;
}

const DEFAULT_CONTENT: ExperienceContent = {
  titleKey: 'site_preview.premium.header.title',
  subtitleKey: 'site_preview.premium.header.subtitle_with_product_count',
  offerCard: {
    urgencyKey: 'site_preview.premium.offer.default.urgency',
    discountKey: 'site_preview.premium.offer.default.discount',
    descriptionKey: 'site_preview.premium.offer.default.description',
    buttonKey: 'site_preview.premium.offer.default.button',
    footerPrefixKey: 'site_preview.premium.offer.default.footer_prefix',
    footerHighlightKey: 'site_preview.premium.offer.default.footer_highlight',
  },
};

const MORRISON_CONTENT: ExperienceContent = {
  titleKey: 'site_preview.premium.header.title',
  subtitleKey: 'site_preview.premium.header.subtitle_with_product_count',
  offerCard: {
    urgencyKey: 'site_preview.premium.offer.morrison.urgency',
    descriptionKey: 'site_preview.premium.offer.morrison.description',
    buttonKey: 'site_preview.premium.offer.morrison.button',
    footerPrefixKey: 'site_preview.premium.offer.morrison.footer',
  },
};

export const DEFAULT_SITE_PREVIEW_EXPERIENCE: SitePreviewExperience = {
  ctaTarget: 'premium',
  content: DEFAULT_CONTENT,
};

export const SITE_PREVIEW_EXPERIENCE_BY_SUBID_VARIANT: Record<SubIdExperienceVariant, SitePreviewExperience> = {
  [SubIdExperienceVariant.Morrison]: {
    ctaTarget: 'dashboard',
    content: MORRISON_CONTENT,
  },
  [SubIdExperienceVariant.Vencedora]: DEFAULT_SITE_PREVIEW_EXPERIENCE,
};
